var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAdp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.332 4.99935V7.01601C18.332 8.33268 17.4987 9.16602 16.182 9.16602H13.332V3.34101C13.332 2.41601 14.0904 1.66602 15.0154 1.66602C15.9237 1.67435 16.757 2.04101 17.357 2.64101C17.957 3.24935 18.332 4.08268 18.332 4.99935Z",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 5.83268V17.4993C1.66797 18.191 2.4513 18.5827 3.0013 18.166L4.4263 17.0993C4.75964 16.8493 5.2263 16.8827 5.5263 17.1827L6.90964 18.5744C7.23464 18.8994 7.76797 18.8994 8.09297 18.5744L9.49297 17.1744C9.78464 16.8827 10.2513 16.8493 10.5763 17.0993L12.0013 18.166C12.5513 18.5744 13.3346 18.1827 13.3346 17.4993V3.33268C13.3346 2.41602 14.0846 1.66602 15.0013 1.66602H5.83464H5.0013C2.5013 1.66602 1.66797 3.15768 1.66797 4.99935V5.83268Z",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.8418H10",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.50781H10",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99609 10.834H5.00358",
    stroke: "#7E7E80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99609 7.5H5.00358",
    stroke: "#7E7E80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/adp.6fbd077c.svg";
export { ForwardRef as ReactComponent };